import React from 'react';
import { TDR } from 'tdr-common';
import Card from '../../../icons/card.svg';
import Shield from '../../../icons/key-shield.svg';
import Lock from '../../../icons/pad-lock.svg';
import { InfoDialog } from './InfoDialog';
import { InfoDrawerIcon } from '../../icons';
import styles from './SecureEncryptInfo.module.scss';
import { useTranslation } from 'react-i18next';

const SecureEncryptInfo = () => {
	const { t } = useTranslation();
	const body = (
		<ul className={styles.InfoList} style={{ textAlign: 'left' }}>
			<li>
				<p>{t('checkout.modals.secure_encrypted.description1')}</p>
			</li>
			<li>
				<img src={Lock} alt={'Lock Icon'} />
				<p>
					{t('checkout.modals.secure_encrypted.description2')}{' '}
					<a className='bolded clickable' href='https://www.ietf.org/rfc/rfc5246.txt' target='_blank' rel='noreferrer'>
						{t('checkout.modals.secure_encrypted.learn_more')}
					</a>
				</p>
			</li>
			<li>
				<img src={Card} alt={'Card Icon'} />
				<p>
					{t('checkout.modals.secure_encrypted.description3')}{' '}
					<a
						className='bolded clickable'
						href='https://stripe.com/en-ca/payments/checkout'
						target='_blank'
						rel='noreferrer'
					>
						{t('checkout.modals.secure_encrypted.learn_more')}
					</a>
				</p>
			</li>
			<li>
				<img src={Shield} alt={'Shield Icon'} />
				<p>
					{t('checkout.modals.secure_encrypted.description4')}{' '}
					<a
						className='bolded clickable'
						href='https://firebase.google.com/docs/firestore'
						target='_blank'
						rel='noreferrer'
					>
						{t('checkout.modals.secure_encrypted.learn_more')}
					</a>
				</p>
			</li>
			<li>
				<p style={{ textAlign: 'center' }}>
					{t('checkout.modals.secure_encrypted.description5')}{' '}
					<a className='bolded clickable' href={`mailto:${TDR.SUPPORT_EMAIL}`}>
						{TDR.SUPPORT_EMAIL}
					</a>
				</p>
			</li>
		</ul>
	);

	return (
		<InfoDialog
			title={t('titles.secure_encrypted', { defaultValue: 'Secure & Encrypted' })}
			body={body}
			triggerButton={<InfoDrawerIcon />}
		/>
	);
};

export default SecureEncryptInfo;
